import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit'
import type {
  CustomerOTPStateType,
  SetCustomerOTPQueryPayloadType,
} from 'features/Account/@types/customerOTP'
import { callErrorMsg } from 'helpers/errorMsg'
import { getCustomerOTPList, putCustomerOTP } from '../../services/customerOTP'

const initialState: CustomerOTPStateType = {
  isLoading: false,
  query: {
    cursor: '',
    page_size: 20,
    page_index: 1,
    phone: '',
    is_active: null,
    user_type: '',
    next_cursor: '',
    previous_cursor: '',
    next_page_exist: false,
    previous_page_exist: false,
  },
  blacklistPhone: [],
}

export const SLICE_NAME = 'customerOTP'

const customerOTPSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    reset: () => initialState,
    setQuery: (state, action: PayloadAction<SetCustomerOTPQueryPayloadType>) => {
      const { name, value } = action.payload
      state.query[name] = value as never
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchCustomerOTPList.pending, (state) => {
        state.isLoading = true
      })
      .addCase(fetchCustomerOTPList.rejected, (state) => {
        state.isLoading = false
      })
      .addCase(fetchCustomerOTPList.fulfilled, (state, action) => {
        state.isLoading = false
        state.blacklistPhone = action.payload.data.blacklist_phones
        state.query.next_cursor = action.payload.pagination.next_cursor
        state.query.previous_cursor = action.payload.pagination.previous_cursor
        state.query.next_page_exist = action.payload.pagination.next_page_exist
        state.query.previous_page_exist = action.payload.pagination.previous_page_exist
      })
      .addCase(releaseOTPBlacklist.pending, (state) => {
        state.isLoading = true
      })
      .addCase(releaseOTPBlacklist.rejected, (state) => {
        state.isLoading = false
      })
      .addCase(releaseOTPBlacklist.fulfilled, (state) => {
        state.isLoading = false
      })
  },
})

export default customerOTPSlice.reducer
export const { reset, setQuery } = customerOTPSlice.actions

export const fetchCustomerOTPList = createAsyncThunk(
  `${SLICE_NAME}/fetchCustomerOTPList`,
  async (_, { rejectWithValue, getState }) => {
    const {
      customerOTP: { query },
    } = getState() as StoreStateType

    try {
      const res = await getCustomerOTPList({
        params: {
          cursor: query.cursor,
          page_size: query.page_size,
          phone: query.phone ?? undefined,
          is_active: query.is_active ?? undefined,
          user_type: query.user_type ?? undefined,
        },
      })
      return res.data
    } catch (error) {
      callErrorMsg(error)
      return rejectWithValue(error)
    }
  },
)

export const releaseOTPBlacklist = createAsyncThunk(
  `${SLICE_NAME}/releaseOTPBlacklist`,
  async ({ id, isActive }: { id: number; isActive: boolean }, { rejectWithValue, dispatch }) => {
    try {
      await putCustomerOTP({
        id,
        body: {
          is_active: isActive,
          released_reason: isActive ? undefined : 'Verified not fraud',
        },
      })
      dispatch(fetchCustomerOTPList())
      return id
    } catch (error) {
      callErrorMsg(error)
      return rejectWithValue(error)
    }
  },
)
